/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  CHIRP-compatible version of nurturing owner information.
 *  <p>This is a CHIRP-compatible equivalent of {@code com.hubspot.nurturingowners.core.NurturingOwnerInfo}
 *  that can be used in CHIRP RPC messages.
 */

/**
 *  Per-cart evaluation result.
 *  <p>{@code cartPurchaseMotions} is the cart-level decision (per-product intersection base + HSoC
 *  overrides). {@code purchaseMotionsByProductApiName} carries per-product motions that sit
 *  alongside the cart motion (e.g. {@code BUY_ADDITIONAL_SEATS}).
 */

/**
 *  One product line in a cart. {@code quantityName} is present only for quantity-pack SKUs — products
 *  that share a product api name but resolve to a different SKU by quantity name (e.g. marketing
 *  contacts); it is absent for the base product.
 */

/**
 *  A single hypothetical purchase to evaluate.
 *  <p>{@code resolvedCartCostUsd} is an optional, transitional pass-in: when present the service
 *  uses it for the ASP band; when absent the service self-computes the cost (lazily, only when the
 *  band is reached). It will be removed once the service self-computes at parity.
 */

/**
 *  Authenticated cart-based purchase-motion evaluation request. One or more resolved carts are
 *  evaluated for the portal/user in the ChirpContext against a single location/surface; portal-level
 *  context is resolved once and shared across every cart. Tier-options surfaces send one cart per
 *  tier card. One location per request keeps each cart's result unambiguous (correlatable by
 *  cartKey); callers needing another surface issue a separate request.
 */

/**
 * One {@link CartEvaluationResult} per input cart, order-preserved and correlatable via cartKey.
 */

export const evaluateInAppRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateInApp',
  auth: 'app',
  fingerprint: 'KDhTXICuQlXrifxQofJJG5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const evaluateInAppV2Rpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateInAppV2',
  auth: 'app',
  fingerprint: 'KDhTXICuQlXrifxQofJJG5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const evaluateInAppCartsRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateInAppCarts',
  auth: 'app',
  fingerprint: 'iobQg0kSxuwGg56HI9en_pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSelfServiceEligibilityRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'getSelfServiceEligibility',
  auth: 'app',
  fingerprint: 'gyjaiV5kkrvzxx1SiW-VnJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const evaluateAssignabilityRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateAssignability',
  auth: 'app',
  fingerprint: 'BzoP5ZQn4ojUw8nX1l3VLpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};